import React from "react";
import { motion } from "framer-motion";
export const NavigationOverlay = ({ children, className, onClose }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(motion.div, { key: "backdrop", initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 }, className: "fixed inset-0 z-dimmer h-screen w-screen", onClick: onClose },
            React.createElement("div", { className: "h-full w-full bg-black-100 opacity-40" })),
        React.createElement("div", { className: "relative z-dimmer" }, children)));
};
